module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-view has-header"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "ui category search"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    staticClass: "prompt",
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": "Search sentences... (at least 3 chars)"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.query()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('div', {
    staticClass: "results"
  })])]), _vm._v(" "), [_c('div', {
    staticClass: "about"
  }, [(_vm.$route.query.dataset == 'DPR') ? [_c('a', {
    attrs: {
      "href": "https://aclweb.org/anthology/papers/I/I17/I17-1100/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'CMRC') ? [_c('a', {
    attrs: {
      "href": "https://github.com/ymcui/cmrc2018"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'DRCD') ? [_c('a', {
    attrs: {
      "href": "https://github.com/DRCKnowledgeTeam/DRCD"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'COPA') ? [_c('a', {
    attrs: {
      "href": "http://people.ict.usc.edu/~gordon/copa.html"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'MultiRC') ? [_c('a', {
    attrs: {
      "href": "https://cogcomp.seas.upenn.edu/multirc/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'WiC') ? [_c('a', {
    attrs: {
      "href": "https://pilehvar.github.io/wic/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'WNLI') ? [_c('a', {
    attrs: {
      "href": "https://cs.nyu.edu/faculty/davise/papers/WinogradSchemas/WS.html"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'ReCoRD') ? [_c('a', {
    attrs: {
      "href": "https://sheng-z.github.io/ReCoRD-explorer/"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'BoolQ') ? [_c('a', {
    attrs: {
      "href": "https://github.com/google-research-datasets/boolean-questions"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'RACE') ? [_c('a', {
    attrs: {
      "href": "http://www.qizhexie.com/data/RACE_leaderboard"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'SciTail') ? [_c('a', {
    attrs: {
      "href": "https://leaderboard.allenai.org/scitail/submissions/get-started"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'Winogrande') ? [_c('p', [_vm._v("A new collection of Winograd Schema Challenge (WSC) problems that are adversarially constructed to be robust against spurious statistical biases. It includes 43,985 instances, half of which are determined as adversarial. A new adversarial filtering algorithm AfLite for systematic bias reduction, combined with a careful crowdsourcing design. The performance of existing state-of-the-art methods remains modest (61.6%) and contrasts with high human performance (90.8%) for the binary questions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://leaderboard.allenai.org/winogrande/submissions/get-started"
    }
  }, [_vm._v("About This Task")])] : (_vm.$route.query.dataset == 'swag') ? [_c('a', {
    attrs: {
      "href": "https://rowanzellers.com/swag/"
    }
  }, [_vm._v("About This Task")])] : [_c('a', {
    attrs: {
      "href": "https://gluebenchmark.com/tasks"
    }
  }, [_vm._v("About This Task")])]], 2)], _vm._v(" "), _c('d-list', {
    attrs: {
      "ds_name": _vm.dataset,
      "items": _vm.data
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "block-button",
    on: {
      "click": _vm.onLoadMore
    }
  }, [_vm._v("More")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-015f255c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 75
// module chunks = 1